import React, { createContext, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Setter simple
  const login = (userData, token) => {
    localStorage.setItem("userData", JSON.stringify(userData));
    localStorage.setItem("token", token);
  };

  // Getter simple
  const getUser = () => {
    const user = localStorage.getItem("userData");
    return user ? JSON.parse(user) : null;
  };

  // Logout
  const logout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider value={{ login, logout, getUser }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook helper
export const useAuth = () => useContext(AuthContext);
